import { httpsCallable } from "firebase/functions";
import Joi from "joi";
import serviceFunction from "src/utils/serviceFunction";

export interface RecordCoachInboxVisitRequest {
  caseId: string;
}

const schema = Joi.object<RecordCoachInboxVisitRequest>({
  caseId: Joi.string()
    .pattern(/^[\w-]{1,128}$/)
    .required(),
});

/**
 * Tells the server the signed-in student opened a coach link for this case.
 * The server checks the case is theirs and that a recent send exists.
 */
const recordCoachInboxVisit = serviceFunction(
  schema,
  async (
    data: RecordCoachInboxVisitRequest,
    { functions }
  ): Promise<{ recorded: boolean }> => {
    const callable = httpsCallable<
      RecordCoachInboxVisitRequest,
      { recorded: boolean }
    >(functions, "recordCoachInboxVisit");
    return (await callable(data)).data;
  }
);

export default recordCoachInboxVisit;
